var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0FB029FD-FCA2-442A-A97D-58A31CE35514") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation-March2020",
    transform: "translate(-45.000000, -41.000000)",
    fillRule: "nonzero",
    stroke: "#006F44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/desktop-header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/hamburger",
    transform: "translate(46.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "misc/hamburger"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.5,
    x2: 16,
    y2: 0.5,
    id: "Line-4",
    transform: "translate(8.000000, 0.500000) rotate(-360.000000) translate(-8.000000, -0.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8.5,
    x2: 16,
    y2: 8.5,
    id: "Line-4-Copy",
    transform: "translate(8.000000, 8.500000) rotate(-360.000000) translate(-8.000000, -8.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 16.5,
    x2: 16,
    y2: 16.5,
    id: "Line-4-Copy-2",
    transform: "translate(8.000000, 16.500000) rotate(-360.000000) translate(-8.000000, -16.500000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.318ee70e8bc234a794c8361496c81b34.svg";
export { ForwardRef as ReactComponent };